import {ApiClient} from '@hconnect/apiclient'
import {useMutation, useQueryClient} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {ApprovalStatus} from '../../approvers/types'

import {QueryKey} from './useEvents'

type UseApprovalParams = {
  plantId: string
}

export const useApproval = ({plantId}: UseApprovalParams) => {
  const queryClient = useQueryClient()

  return useMutation<never, AxiosError, {eventId: string; approvalStatus: ApprovalStatus}>({
    mutationFn: async ({eventId, approvalStatus}) => {
      const path = `/shifthandover/${plantId}/events/${eventId}/approval`
      const {data} = await ApiClient.axiosInstance.put<never>(path, approvalStatus, {
        headers: {
          // Need to override content type cause axios sets it to application/x-www-form-urlencoded if plain string is passed in body
          'Content-Type': 'application/json'
        }
      })
      return data
    },
    onSuccess: async (data, variables) => {
      await queryClient.invalidateQueries({queryKey: [QueryKey, variables.eventId]})
    }
  })
}
